import styled from "styled-components";

export const UserDetailsStyled = styled.div`
  .tab-content {
    padding: 16px 36px !important;
  }

  .css-1ujnqem-MuiTabs-root {
    width: 355px;
  }
  .css-orq8zk {
    width: 355px;
  }
  .delete-icon {
    display: flex;
    justify-content: end;
    margin-top: 20px;
  }

  .head-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer {
    padding: 20px;
    position: fixed;
    bottom: 0;
    width: -webkit-fill-available;
    .space-between {
      display: flex;
      justify-content: space-between;
      .created {
        display: grid;
      }
    }
  }
`;
